import { productIdFormat } from "@redotech/redo-model/ids";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const forecastingProductSchema_ = z.object({
  id: productIdFormat.schema,
  image: z.string().nullish(),
  title: z.string(),
  sku: z.string().nullish(),
  vendor: z.string().nullish(),
  stockoutDate: zExt.plainDate().nullish(),
  totalQuantity: z.number(),
  totalAvailable: z.number(),
  totalCommitted: z.number(),
  totalReserved: z.number(),
});

export const ForecastingProductSchema: z.ZodType<ForecastingProduct> =
  forecastingProductSchema_;
export interface ForecastingProduct
  extends z.infer<typeof forecastingProductSchema_> {}

export const getForecastingProducts = {
  name: "getForecastingProducts" as const,
  input: z.object({
    today: zExt.plainDate(),
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int(),
    search: z.string().optional(),
    sortBy: z
      .enum([
        "title",
        "sku",
        "vendor",
        "daysOfStockRemaining",
        "totalAvailable",
        "totalQuantity",
        "totalCommitted",
        "totalReserved",
      ])
      .optional(),
    sortDirection: z.enum(["asc", "desc"]).optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    products: z.array(ForecastingProductSchema),
    totalCount: z.number().int(),
  }),
};
